export const projects = [
  {
    id: 1,
    title: "AlgoViz — Array Visualizer",
    shortDescription:
      "An interactive web app that animates sorting and searching algorithms step-by-step on custom arrays. Built as a final year capstone to make algorithms more intuitive.",
    description:
      "AlgoViz is a browser-based algorithm visualization tool that animates how sorting and searching algorithms operate on arrays in real time. Users can input custom arrays, control playback speed, and step through each operation manually to understand exactly what the algorithm is doing at each stage.",
    problem:
      "Most CS students learn algorithms from static textbook diagrams and pseudocode. Watching an algorithm actually move data — with color-coded comparisons, swaps, and pointer movement — builds intuition that reading alone cannot. AlgoViz was built to fill that gap.",
    approach:
      "Built entirely in React with no backend. Each algorithm is implemented in JavaScript using generator functions that yield intermediate array states at every step. These states are queued and played back as animations using React state and CSS transitions.",
    decisions: [
      // "Generator functions used to produce each algorithm step lazily — keeps algorithm logic clean and fully separate from rendering",
      // "React state machine pattern to manage play / pause / step / reset controls without logic leaking into the UI",
      // "CSS transitions over a canvas approach — simpler to implement, easier to style, and accessible by default",
      // "Deployed as a static site on GitHub Pages — no server needed, zero running costs",
    ],
    tech: ["React", "JavaScript", "CSS", "HTML", "GitHub Pages"],
    github: null,
    demo: null,
    featured: true,
    image: null,
  },
  // {
  //   id: 2,
  //   title: 'Task Manager App',
  //   shortDescription:
  //     'A full-stack CRUD task manager with user authentication, built to practice REST API design and connecting a React frontend to a Node.js backend.',
  //   description:
  //     'A full-stack task management application where users can register, log in, create tasks, mark them complete, and delete them. Built primarily as a learning project to understand how a React frontend communicates with a REST API and how data is persisted in a database.',
  //   problem:
  //     'After completing front-end courses, I had no practical experience wiring a React app to a real backend with a database. This project was deliberately scoped to cover that full vertical slice end-to-end.',
  //   approach:
  //     'React frontend with component-level state, a Node.js/Express REST API with JWT-based authentication, and a PostgreSQL database for persistence. Deployed the backend on Render and the frontend on Netlify.',
  //   decisions: [
  //     'JWT stored in httpOnly cookies rather than localStorage to avoid XSS exposure',
  //     'Express Router used to separate auth routes from task routes cleanly',
  //     'PostgreSQL over SQLite — wanted practice with a real relational database rather than a file-based one',
  //     'Kept the UI minimal intentionally — the learning goal was the backend, not the design',
  //   ],
  //   tech: ['React', 'Node.js', 'Express', 'PostgreSQL', 'JWT', 'Netlify', 'Render'],
  //   github: 'https://github.com/yourusername/task-manager',
  //   demo: null,
  //   featured: false,
  //   image: null,
  // },
  // Ideas in progress: a REST API with Python + FastAPI, or a real-time chat app with WebSockets.
  {
    id: 2,
    title: "// Next Project",
    shortDescription: "Currently scoping the next project.",
    description: "",
    problem: "",
    approach: "",
    decisions: [],
    tech: [],
    github: null,
    demo: null,
    featured: false,
    inProgress: true,
    image: null,
  },
];
